import React, { useState } from "react";
import "./ResearchManager.css";

import researchData from "../data/researchData";

const PIN = "2004";

const ResearchManager = () => {

  const [papers, setPapers] = useState(researchData);

  const [open, setOpen] = useState(false);

  const [authenticated, setAuthenticated] = useState(false);

  const [pin, setPin] = useState("");

  const [paperTitle, setPaperTitle] = useState("");

  const [paperLink, setPaperLink] = useState("");

  const handleLogin = () => {
    if (pin === PIN) {
      setAuthenticated(true);
    } else {
      alert("Wrong PIN");
    }
  };

  const addPaper = () => {

    if (!paperTitle || !paperLink) {
      alert("Fill all fields");
      return;
    }

    const newPaper = {
      title: paperTitle,
      link: paperLink,
    };

    setPapers([newPaper, ...papers]);

    setPaperTitle("");
    setPaperLink("");
  };

  const deletePaper = (index) => {
    const updated = papers.filter((_, i) => i !== index);
    setPapers(updated);
  };

  return (
    <>
      {/* FLOATING BUTTON */}
      <button
        className="research-float-btn"
        onClick={() => setOpen(!open)}
      >
        📚
      </button>

      {/* ADMIN PANEL */}
      {open && (
        <div className="research-admin-panel">

          {!authenticated ? (
            <div className="login-box">

              <h2>🔒 Research Admin</h2>

              <input
                type="password"
                placeholder="Enter PIN"
                maxLength={4}
                value={pin}
                onChange={(e) => setPin(e.target.value)}
              />

              <button onClick={handleLogin}>
                Unlock
              </button>

            </div>
          ) : (
            <div className="research-editor">

              <h2>📑 Add Research Paper</h2>

              <input
                type="text"
                placeholder="Paper Name"
                value={paperTitle}
                onChange={(e) => setPaperTitle(e.target.value)}
              />

              <input
                type="text"
                placeholder="Paper Link"
                value={paperLink}
                onChange={(e) => setPaperLink(e.target.value)}
              />

              <button onClick={addPaper}>
                Add Paper
              </button>

              <div className="paper-list">

                {papers.map((paper, index) => (

                  <div key={index} className="paper-item">

                    <a
                      href={paper.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {paper.title}
                    </a>

                    <button
                      className="delete-btn"
                      onClick={() => deletePaper(index)}
                    >
                      ✖
                    </button>

                  </div>
                ))}

              </div>

            </div>
          )}
        </div>
      )}
{/* RESEARCH DISPLAY */}
<section className="dynamic-research-section" id="research">

  <h2>📚 Research Publications</h2>

  <div className="dynamic-paper-grid">

    {papers.map((paper, index) => (

      <div
        key={index}
        className="dynamic-paper-card"
      >

        <span className="paper-number">
          {String(index + 1).padStart(2, "0")}
        </span>

        <h3>{paper.title}</h3>

        <p className="paper-meta">
          {paper.journal} • {paper.year}
        </p>

        <a
          href={paper.scholar}
          target="_blank"
          rel="noreferrer"
          className="paper-btn"
        >
          🔍 View on Google Scholar
        </a>

      </div>

    ))}

  </div>

</section>
    </>
  );
};

export default ResearchManager;